import {multiLanguageValue} from "./lib";
import {generateUid} from "../../ApplicationBuilder/ApplicationDesigner/Designers/ScreenDesigner/utils/lib";

const generateLabel = (label, recordId) => {

    return {
        "properties": {
            "label": {
                "en": recordId ? `Update ${multiLanguageValue(label, 'en')}` : `Create ${multiLanguageValue(label, 'en')}`,
            }
        },
        "styles": [
            {
                "fontSize": "20px",
                "width": "100%",
                "fontWeight": "bold",
                "className": "title"
            }
        ],
        "type": "label",
        "id": generateUid({type: "label"})
    }
}
const actions = (recordId, entityName, isPreview) => {

    let actionButtons = [
        {
            "properties": {
                "label": {
                    "en": "Save"
                },
                "type": "default",
                "validateFields": false,
                "startIcon": {
                    "icon": "save",
                    "iconType": "symbols-outlined"
                }
            },
            "styles": [
                {
                    "padding": "6px 16px 6px 16px",
                    "margin": "0px",
                    "background": "primary",
                    "variant": "contained",
                    "fontSize": "13px",
                    "width": "110px",
                    "height": "auto"
                }
            ],
            "events": [
                {
                    event: "onClick",
                    actions: [
                        {
                            param: [{}],
                            type: "updateEntity",
                            destination: entityName
                        }
                    ]
                }
            ],
            "type": "button",
            "id": generateUid({type: "button"}),
            visible: entityName && !isPreview
        },
        {
            "properties": {
                "label": {
                    "en": "Close"
                },
                "type": "default",
                "validateFields": false,
                "startIcon": "cancel"
            },
            "styles": [
                {
                    "padding": "6px 8px 6px 8px",
                    "margin": "0px 0px 0px 0",
                    "background": "default",
                    "variant": "contained",
                    "fontSize": "13px",
                    "width": "110px"
                }
            ],
            "events": [
                {
                    actions: [
                        {
                            param: [{}],
                            type: "cancel"
                        }
                    ],
                    "event": "onClick"
                }
            ],
            "type": "button",
            "id": generateUid({type: "button"}),
            visible: true,
        },
        {
            "properties": {
                "label": {
                    "en": "Delete"
                },
                "type": "default",
                "validateFields": false,
                "startIcon": "delete"
            },
            "styles": [
                {
                    "padding": "6px 8px 6px 8px",
                    "margin": "0px 0px 0px 5px",
                    "background": "secondary",
                    "variant": "contained",
                    "fontSize": "13px",
                    "width": "110px"
                }
            ],
            "events": [
                {
                    "actions": [
                        {
                            param: [{}],
                            type: "deleteEntity",
                            recordId: recordId,
                            destination: entityName
                        }
                    ],
                    "event": "onClick"
                }
            ],
            "type": "button",
            "id": generateUid({type: "button"}),
            visible: (recordId && entityName) && !isPreview,
        },
    ]
    return actionButtons.filter(button => button.visible)
}
function generateFields(schema) {

    let orgSchema = schema.reduce((acc, cur) => {

        //skip label component for Audit object
        if(cur.properties.label === "Audit") return acc;

        if(cur.properties.path?.includes('_audit')) {
            acc.auditFields = [...acc.auditFields, cur];
        }
        if(!cur.properties.path?.includes('_audit')) {
            acc.mainFields = [...acc.mainFields, cur];
        }

        return acc;
    }, {
        mainFields: [],
        auditFields: []
    })

    return {
        mainFields: orgSchema.mainFields,
        auditFields: orgSchema.auditFields,
    };
}
const defaultScreenNew = ({schema = [], entityName, recordId, label = "", isPreview}) => {
    let generatedFields = generateFields(schema)
    let mainFields = generatedFields.mainFields;
    let auditFields = generatedFields.auditFields;
    let tabs = [
        {
            visible: true,
            "type": "tab",
            "properties": {
                "label": {
                    "en": "Main Information"
                },
                "renderWhenVisible": true
            },
            "styles": [
                {}
            ],
            "id": generateUid({type: "tab"}),
            "children": [
                {
                    "styles": [
                        {
                            "display": "flex",
                            "width": "100%",

                            "overflow": "auto",
                            "padding": "10px 10px 10px 10px",
                            "gap": "10",
                            "borderRadius": "8"
                        }
                    ],
                    "type": "block",
                    "id": generateUid({type: "block"}),
                    "children": [
                        {
                            "styles": [
                                {
                                    "display": "flex",
                                    "width": "100%",
                                    "height": "100%",
                                    "overflow": "auto",
                                    "padding": "10px 10px 20px 10px",
                                    "className": "blockWithShadow",
                                    "borderRadius": "8"
                                }
                            ],
                            "type": "block",
                            "id": "block_ljico1",
                            "children": mainFields
                        }
                    ]
                }
            ]
        },
        {
            visible: Boolean(auditFields.length),
            "type": "tab",
            "properties": {
                "label": {
                    "en": "Audit"
                },
                "renderWhenVisible": true
            },
            "styles": [
                {}
            ],
            "id": generateUid({type: "tab"}),
            "children": [
                {
                    "styles": [
                        {
                            "display": "flex",
                            "width": "100%",
                            "height": "100%",
                            "overflow": "auto",
                            "gap": "10",
                            "padding": "10px 10px 10px 10px"
                        }
                    ],
                    "type": "block",
                    "id": generateUid({type: "block"}),
                    "children": [
                        {
                            "styles": [
                                {
                                    "display": "flex",
                                    "width": "100%",
                                    "height": "100%",
                                    "padding": "10px 10px 20px 10px",
                                    "overflow": "auto",
                                    "className": "blockWithShadow",
                                    "borderRadius": "8"
                                }
                            ],
                            "type": "block",
                            "id": generateUid({type: "block"}),
                            "children": auditFields
                        }
                    ]
                }
            ]
        }
    ].filter(item => item.visible);
    let labelValue = generateLabel(label, recordId)

    return [
        {
            "styles": [
                {
                    "display": "flex",
                    "width": "100%",
                    "height": "55px",
                    "overflow": "visible",
                    "flexDirection": "row",
                    "alignItems": "center",
                    "padding": "15px 30px 5px 30px",
                    "className": "edit_header",
                    "mobile": {
                        "height": "50px",
                        "width": "100%",
                        "flexDirection": "row"
                    }
                }
            ],
            "type": "block",
            "id": generateUid({type: "block"}),
            "children": [
                {
                    "styles": [
                        {
                            "display": "flex",
                            "width": "40%",
                            "height": "auto",
                            "overflow": "auto",
                            "mobile": {
                                "width": "50%"
                            }
                        }
                    ],
                    "type": "block",
                    "id": generateUid({type: "block"}),
                    "children": [
                        labelValue
                    ]
                },  //label
                {
                    "styles": [
                        {
                            "display": "flex",
                            "width": "60%",
                            "height": "auto",
                            "padding": "0 5px 0 0",
                            "overflow": "visible",
                            "flexDirection": "row",
                            "justifyContent": "flex-end",
                            "mobile": {
                                "flexDirection": "row",
                                "width": "50%"
                            },
                            "gap": "10"
                        }
                    ],
                    "type": "block",
                    "id": generateUid({type: "block"}),
                    "children": actions(recordId, entityName, isPreview)
                }   //actions
            ]
        },
        {
            "styles": [
                {
                    "display": "flex",
                    "width": "100%",
                    "height": "90%",
                    "overflow": "auto",
                    "className": "edit_body"
                }
            ],
            "type": "block",
            "id": generateUid({type: "block"}),
            "children": [
                {
                    "styles": [
                        {
                            "indicatorColor": "primary",
                            "width": "100%",
                            "height": "98%"
                        }
                    ],
                    "type": "tabs",
                    "id": generateUid({type: "tabs"}),
                    "children": tabs
                }
            ]
        }
    ]
}
export default defaultScreenNew